import * as C from '../../constants';
import clientPaymentService from '../../../../services/payment-service/client-payment-service';
import downloadService from '../../../../services/download-service';

export default {
  /**
   * @param commit
   */
  clearState({ commit }) {
    commit(C.CLIENT_PAYMENTS_CLEAR);
  },

  /**
   * @param commit
   * @returns {Promise<T | never>}
   */
  getFilterData({ commit }) {
    commit(C.CLIENT_PAYMENTS_FILTER_LOAD_PENDING);
    return clientPaymentService.getFilterData()
      .then((res) => {
        commit(C.CLIENT_PAYMENTS_FILTER_LOAD_SUCCESS, res.data);
      })
      .catch(() => {
        commit(C.CLIENT_PAYMENTS_FILTER_LOAD_FAILURE);
      });
  },

  /**
   * @param commit
   * @param state
   * @returns {Promise<T | never>}
   */
  loadTableData({ commit, state }) {
    commit(C.CLIENT_PAYMENTS_LIST_LOAD_PENDING);
    return clientPaymentService.getTableData(
      state.filter.date,
      state.filter.data,
    )
      .then((res) => {
        commit(C.CLIENT_PAYMENTS_LIST_LOAD_SUCCESS, res.data);
      })
      .catch(() => {
        commit(C.CLIENT_PAYMENTS_LIST_LOAD_FAILURE);
      });
  },

  /**
   * @param commit
   * @param state
   */
  downloadPayments({ commit, state }) {
    commit(C.CLIENT_PAYMENTS_LIST_DOWNLOAD_PENDING);
    clientPaymentService.downloadPayments(
      state.filter.lastSearch.date,
      state.filter.lastSearch.data,
    )
      .then((res) => {
        commit(C.CLIENT_PAYMENTS_LIST_DOWNLOAD_SUCCESS);
        downloadService.downloadCsv('client_payments', res.data);
      })
      .catch(() => {
        commit(C.CLIENT_PAYMENTS_LIST_DOWNLOAD_FAILURE);
      });
  },

  /**
   * @param commit
   * @param state
   * @param domain
   */
  downloadPaymentSpecifications({ commit, state }, domain) {
    commit(C.CLIENT_PAYMENTS_SPEC_DOWNLOAD_PENDING, domain.name);
    clientPaymentService.downloadPaymentSpecifications(
      state.filter.lastSearch.date,
      domain.id,
    )
      .then((res) => {
        commit(C.CLIENT_PAYMENTS_SPEC_DOWNLOAD_SUCCESS);
        downloadService.downloadCsv(`client_payments_specifications_${domain.name}`, res.data);
      })
      .catch(() => {
        commit(C.CLIENT_PAYMENTS_SPEC_DOWNLOAD_FAILURE);
      });
  },

  /**
   * @param commit
   * @param state
   * @param arrivalFromDate
   */
  updateFilterArrivalFromDate({ commit, state }, arrivalFromDate) {
    commit(C.CLIENT_PAYMENTS_FILTER_ARRIVAL_FROM_CHANGE, arrivalFromDate);
    const arrivalToDate = state.filter.date.arrivalToDate;
    if (arrivalFromDate > arrivalToDate) {
      commit(C.CLIENT_PAYMENTS_FILTER_ARRIVAL_TO_CHANGE, arrivalFromDate);
    }
  },

  /**
   * @param commit
   * @param arrivalToDate
   */
  updateFilterArrivalToDate({ commit }, arrivalToDate) {
    commit(C.CLIENT_PAYMENTS_FILTER_ARRIVAL_TO_CHANGE, arrivalToDate);
  },

  /**
   * @param commit
   * @param state
   * @param paidDateFromDate
   */
  updateFilterPaidDateFromDate({ commit, state }, paidDateFromDate) {
    commit(C.CLIENT_PAYMENTS_FILTER_PAID_FROM_CHANGE, paidDateFromDate);
    const paidDateToDate = state.filter.date.paidDateToDate;
    if (paidDateFromDate > paidDateToDate) {
      commit(C.CLIENT_PAYMENTS_FILTER_PAID_TO_CHANGE, paidDateFromDate);
    }
  },

  /**
   * @param commit
   * @param paidDateToDate
   */
  updateFilterPaidDateToDate({ commit }, paidDateToDate) {
    commit(C.CLIENT_PAYMENTS_FILTER_PAID_TO_CHANGE, paidDateToDate);
  },

  /**
   * @param commit
   * @param brands
   */
  updateSelectedBrands({ commit }, brands) {
    commit(C.CLIENT_PAYMENTS_FILTER_BRANDS_CHANGE, brands);
  },

  /**
   * @param commit
   * @param domains
   */
  updateSelectedDomains({ commit }, domains) {
    commit(C.CLIENT_PAYMENTS_FILTER_DOMAINS_CHANGE, domains);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/payments/clientPayments/actions.js